import {useRecommendationsExcludingSentApplications} from "../../application/hooks/use_recommendations_excluding_sent_applications";
import {useGetOfferDetailApplicationQuery} from "../../offer/api/get_offer_detail";
import {useGetPropertyDetailApplicationQuery} from "../../property/api/get_property_detail";
import {useLeadRequiredParams} from "./use_lead_required_params";

interface IRecommendationsFetchParams {
    distanceInKm: number;
    maxPrice?: number;
    skip?: boolean;
}

export function useLeadModalParamsRecommendations(params: IRecommendationsFetchParams) {
    const {maxPrice, distanceInKm, skip} = params;

    const {offerId, propertyId} = useLeadRequiredParams("property");
    const {data: propertyDetail, isLoading: propertyLoading, isUninitialized: propertyUninitialized} = useGetPropertyDetailApplicationQuery(propertyId);
    const {data: offerDetail, isLoading: offerLoading, isUninitialized: offerUninitialized} = useGetOfferDetailApplicationQuery(offerId);

    const {results: recommendedProperties, isLoading: recommendationsLoading} = useRecommendationsExcludingSentApplications({
        offer: offerDetail,
        property: propertyDetail,
        distanceInKm,
        maxPrice,
        skip: skip || !offerDetail || !propertyDetail
    });

    const detailsUninitialized = propertyUninitialized || offerUninitialized;

    return {
        isLoading: recommendationsLoading || propertyLoading || offerLoading || detailsUninitialized,
        recommendedProperties
    };
}
import {useRecommendationsExcludingSentApplications} from "../../application/hooks/use_recommendations_excluding_sent_applications";
import {useGetOfferDetailApplicationQuery} from "../../offer/api/get_offer_detail";
import {useGetPropertyDetailApplicationQuery} from "../../property/api/get_property_detail";
import {useLeadRequiredParams} from "./use_lead_required_params";

interface IRecommendationsFetchParams {
    distanceInKm: number;
    maxPrice?: number;
    skip?: boolean;
}

export function useLeadModalParamsRecommendations(params: IRecommendationsFetchParams) {
    const {maxPrice, distanceInKm, skip} = params;

    const {offerId, propertyId} = useLeadRequiredParams("property");
    const {data: propertyDetail, isLoading: propertyLoading, isUninitialized: propertyUninitialized} = useGetPropertyDetailApplicationQuery(propertyId);
    const {data: offerDetail, isLoading: offerLoading, isUninitialized: offerUninitialized} = useGetOfferDetailApplicationQuery(offerId);

    const {results: recommendedProperties, isLoading: recommendationsLoading} = useRecommendationsExcludingSentApplications({
        offer: offerDetail,
        property: propertyDetail,
        distanceInKm,
        maxPrice,
        skip: skip || !offerDetail || !propertyDetail
    });

    const detailsUninitialized = propertyUninitialized || offerUninitialized;

    return {
        isLoading: recommendationsLoading || propertyLoading || offerLoading || detailsUninitialized,
        recommendedProperties
    };
}
